<template>
  <div class="partnet-point-show">
    <p v-if="fetching">
      <Loading />
    </p>
    <template v-else>

      <div class="partnet-point-show__header d-flex justify-content-between align-items-center">
        <button class="s-p-3" @click="$router.back()">
          <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.28033 0.46967C8.5466 0.735936 8.5708 1.1526 8.35295 1.44621L8.28033 1.53033L1.811 8L8.28033 14.4697C8.5466 14.7359 8.5708 15.1526 8.35295 15.4462L8.28033 15.5303C8.01406 15.7966 7.5974 15.8208 7.30379 15.6029L7.21967 15.5303L0.21967 8.53033C-0.0465965 8.26406 -0.0708027 7.8474 0.147052 7.55379L0.21967 7.46967L7.21967 0.46967C7.51256 0.176777 7.98744 0.176777 8.28033 0.46967Z"
              fill="#666666" />
          </svg>
        </button>

        <div>異業點數交換</div>
        <div class="s-p-3"></div>
      </div>

      <div class="s-p-3 min-vh-100">

        <Item :item="item"></Item>


        <template v-if="step === 'init'">
          <div class="partnet-point-show__info">
            <ul class="partnet-point-show__info__range">
              <li>兌換活動期間：2025/01/01 - 2025/06/30</li>
              <li>序號兌換效期：2025/01/01 - 2025/12/31</li>
            </ul>

            <div class="divider my-2"></div>


            <div class="partnet-point-show__info__title">兌換注意事項</div>
            <ol>
              <li>優惠適用於所有寶雅會員 。</li>
              <li>會員帳戶必須持有該預訂於使用優惠代碼折扣前的足夠里數, 才可應用此優惠代碼。</li>
              <li>聯營信用卡額外9折里數兌換全球飯店及租車獎勵之優惠，只適用於台灣「亞洲萬里通」聯營信用卡持卡人，並須受「亞洲萬里通」聯營信用卡兌換禮遇項目內之條款及細則約束。</li>
              <li>此優惠代碼只供會員透過網頁直接使用，並不能通過或經由第三方使用。 </li>
              <li>每筆交易只能使用一次優惠代碼，並不能與其他推廣折扣優惠同時使用（聯營信用卡折扣優惠除外）。</li>
              <li>預訂多於一晚之酒店住宿時，優惠會以每晚房間所需里數平均計算。</li>
              <li>此優惠代碼只適用於推廣期內進行之網頁預訂，並不可轉讓，任何後續之預訂（包括補購里數及預訂更改 ）將不能享有此優惠。</li>
              <li>優惠適用於所有寶雅會員 。</li>
              <li>會員帳戶必須持有該預訂於使用優惠代碼折扣前的足夠里數, 才可應用此優惠代碼。</li>
              <li>聯營信用卡額外9折里數兌換全球飯店及租車獎勵之優惠，只適用於台灣「亞洲萬里通」聯營信用卡持卡人，並須受「亞洲萬里通」聯營信用卡兌換禮遇項目內之條款及細則約束。</li>
              <li>此優惠代碼只供會員透過網頁直接使用，並不能通過或經由第三方使用。 </li>
              <li>每筆交易只能使用一次優惠代碼，並不能與其他推廣折扣優惠同時使用（聯營信用卡折扣優惠除外）。</li>
              <li>預訂多於一晚之酒店住宿時，優惠會以每晚房間所需里數平均計算。</li>
              <li>此優惠代碼只適用於推廣期內進行之網頁預訂，並不可轉讓，任何後續之預訂（包括補購里數及預訂更改 ）將不能享有此優惠。</li>
            </ol>
          </div>
        </template>

        <template v-if="step === 'confirm'">
          <div class="divider mt-2">兌換序號</div>

          <div v-for="(i, idx) in sns" :key="idx"
            class="s-bg-white rounded rounded-2 d-flex align-items-center justify-content-between p-2 mb-1">
            <div class="font-weight-bold flex-fill text-center">{{ i }}</div>
            <button class="s-btn s-btn-primary s-btn-sm s-text-xs w-auto text-nowrap py-2 px-3"
              v-b-tooltip.click="'已複製'">複製</button>
          </div>


        </template>





      </div>


      <div class="footer p-3">

        <template v-if="step === 'init'">
          <div class="s-text-xs mb-3">可用點數 <span class="s-text-secondary s-text-xl">5,250</span></div>
          <div class="d-flex justify-content-between align-items-center">
            <div class="mr-3 flex-fill">
              <button class="s-btn s-btn-sm px-4 partnet-point-show__redeem-solution" v-b-modal.modal-redeem-solution>{{ redeemSolution }}</button>


              <b-modal id="modal-redeem-solution" centered>

                <template #modal-header="{ close }">


                  <div>選擇兌換方案</div>
                  <!-- Emulate built in modal header close button action -->
                  <b-button variant="link" @click="close()" class="close">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
                        fill="#666666" />
                    </svg>

                  </b-button>


                </template>

                <div class="px-3 pt-3">

                  <b-form-radio v-for="(i, idx) in ['50 點 → 50 點', '200 點 → 220 點', '500 點 → 600 點']" v-model="redeemSolution" :key="idx" :value="i"
                    class="mb-3">{{ i
                    }}</b-form-radio>

                </div>

                <template #modal-footer="{ close }">
                  <div class="w-100">
                    <button class="s-btn s-btn-primary s-btn-sm px-4" @click="close()">確認</button>
                  </div>
                </template>
              </b-modal>

            </div>
            <div>
              <b-form-spinbutton min="1" max="100"></b-form-spinbutton>
            </div>
          </div>

          <div class="text-center my-2">
            <b-form-checkbox size="sm" value="accepted">
              我已同意注意事項
            </b-form-checkbox>
          </div>

          <button class="s-btn s-btn-primary s-btn-sm px-4" @click="redeem">確認</button>
        </template>

        <template v-if="step === 'confirm'">
          <button class="s-btn s-btn-primary s-btn-sm px-4">完成</button>
        </template>

      </div>

    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Loading from '@/components/Page/Liff/Shared/Loading'
import list from '@/mixins/liff/memberCard/list'
import Item from '@/components/Page/Liff/MemberCard/PartnetPoint/Item.vue';

export default {
  mixins: [list],
  components: { Loading, Item },
  data: () => ({
    item: {
      title: '亞洲萬里通',
      exchange: [{
        from: { value: 1000, unit: '點' },
        to: { value: 100, unit: '哩程' },
      }],
      partner_org_hashid: '123',
      image: 'image-0.png',
     
    },
    redeemSolution: '50 點 → 50 點',
    step: 'init',
    sns: ['HAMIDKJSFPOINT', 'HAMIDKLJKEPOINT', 'HAMICKJDEOPOINT', 'HAMI123EDCPOINT']
  }),
  methods: {
    ...mapActions({
      getTransactions: 'liffMemberCard/getTransactions',
    }),
    async fetch() {

    },
    redeem() {
      this.$swal({
        html: "您目前有 5,250 點<br>確定使用 200 點兌換嗎？",
        showConfirmButton: true,
        confirmButtonText: "確定",
        showCancelButton: true,
        cancelButtonText: "取消",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.step = 'confirm'
        }
      });
    },
  }
}
</script>

<style>
.s-container {
  padding-bottom: 0 !important;
}
</style>
<style lang="scss" scoped>
.partnet-point-show {
  margin: -1rem -0.75rem 0;

  &__header {
    background-color: var(--s-white);
    position: sticky;
    top: 0;
    z-index: 1000;
    line-height: 100%;
  }

  &__info {
    font-size: 14px;
    color: #333333;
    line-height: 150%;

    ol {
      padding-left: 1.5rem;
      list-style: decimal;
    }

    ul {
      padding-left: 1.5rem;
      list-style: disc;
    }



    &__title {
      font-weight: 500;
      font-size: 14px;
    }

    &__range {
      font-weight: 500;

      li::marker {
        color: var(--s-primary);
      }
    }
  }

  &__point {
    font-weight: 500;
    font-size: 32px;
    color: black;
    line-height: 100%;
    padding: 1rem 0;

    > :first-child {
      border-right: 3px solid #E3E3E3;
    }
  }

  &__redeem-solution {
    border-radius: 0.25rem;
    border: 1px solid #cdd6dc;
    padding: 0.7rem 0.81rem;
    font-size: 1rem;
    font-weight: 400;
    justify-content: start;
  }



  .footer {
    position: sticky;
    bottom: 0;
    background-color: var(--s-white);
    z-index: 1000;
    padding: 1rem 0;
    border-top: 1px solid #E3E3E3;

    ::v-deep .custom-select {
      padding: 0.375rem 1.75rem 0.375rem 0.75rem;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;
      color: #495057;
      border-width: 1px;
      height: 45px;
    }

    ::v-deep .b-form-spinbutton {
      border-width: 1px;
      border-radius: 0.25rem;
      width: auto;

      >button {
        padding: 0.5rem 0.81rem;

        &:last-child {
          color: var(--s-primary);
        }
      }

      >output {
        padding: 0 1rem;
      }
    }

    ::v-deep .custom-checkbox {
      .custom-control-label::before {
        border-width: 1px;
      }

      .custom-control-input:checked~.custom-control-label::before {
        background-color: var(--s-primary);
        border-color: var(--s-primary);
      }
    }

  }
}

.s-text-secondary {
  color: #FE577F !important;
}

::v-deep .modal-backdrop {
  opacity: .5;
}

::v-deep .modal {

  --s-primary: #FE577F;

  


  &.fade .modal-dialog {
    transform: translateY(10%);
    transition: transform 0.3s ease-out;
  }

  &.show .modal-dialog {
    transform: translateY(0);
  }


  .modal-dialog {

    margin: auto;

    .modal-header {
      justify-content: center;
      align-items: center;
      position: relative;

      .close {
        position: absolute;
        right: 0;
        margin: 0;
      }
    }

    .modal-content {
      border-radius: .3rem .3rem 0 0;
      border: none;
    }

    &.modal-dialog-centered {
      align-items: end;

      min-height: calc(100%);
      
    }
  }

  .s-btn {
    color: white !important;
  }


}
</style>
